import { get } from 'lodash';
import React from 'react';
import { Field } from 'formik';

import { RadioButton, RadioButtonProps } from 'src/kit';

export type FormikRadioButtonProps = Omit<RadioButtonProps, 'checked' | 'onChange'> & {
  id: string | boolean;
  name: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  children: React.ReactNode;
  validate?: any;
};

const FormikRadioButton = ({ id, validate, name, onChange, ...rest }: FormikRadioButtonProps) => (
  <Field name={name} {...(validate ? { validate } : {})}>
    {({ field: { value }, form: { errors, touched, setFieldValue, setFieldTouched } }) => {
      const error = get(touched, name) && get(errors, name);

      return (
        <RadioButton
          id={id}
          name={name}
          error={error}
          checked={value === id}
          onChange={event => {
            setFieldValue(name, id);
            if (onChange) {
              onChange(event);
            }
          }}
          onBlur={() => setFieldTouched(name)}
          {...rest}
        />
      );
    }}
  </Field>
);

export default FormikRadioButton;
